import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Loader from './Loader';
// import registerServiceWorker from './registerServiceWorker';

const rootElement = document.getElementById('root') as HTMLElement;
ReactDOM.render(<Loader />, rootElement);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx